import { customFieldTheme, ExpandableText, Stack } from "@skailer-com/uikit";
import { ReactNode } from "react";

interface CustomFieldHintProps {
  hint?: string | null;
  children: ReactNode;
}

export const CustomFieldHint = ({ hint, children }: CustomFieldHintProps) => {
  const text = hint?.trim();
  if (!text || !children) return children;

  return (
    <Stack gap="xs">
      {children}
      <ExpandableText maxLines={3} className={customFieldTheme.hint}>
        {text}
      </ExpandableText>
    </Stack>
  );
};
